import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import App from "./App";
import { AuthProvider } from "@/lib/auth-context";
import { initSentry } from "@/lib/sentry";
import { reloadForStaleChunk } from "@/lib/stale-chunk";
// Inter auto-hébergée (RGPD : aucune requête vers Google Fonts, donc aucun
// transfert d'adresse IP hors UE). Mêmes graisses que l'ancien lien Google.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "./styles/globals.css";

// Init Sentry BEFORE createRoot so the SDK is ready to capture React
// render errors / hook bugs / network errors from the very first frame.
// No-op when VITE_SENTRY_DSN is empty (default in dev). See #25.
await initSentry();

// Préchargement Vite d'un chunk supprimé par un déploiement : on recharge
// une fois au lieu de laisser l'erreur remonter (cf. lib/stale-chunk.ts).
window.addEventListener("vite:preloadError", (event) => {
  if (reloadForStaleChunk()) event.preventDefault();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
